/** Default self-scan acceptance radius (meters) when creating a venue. */
export const MIQAAT_VENUE_DEFAULT_RADIUS_METERS = 150;

/** Empty / blank optional number fields → undefined (API coerces the same way). */
export function parseOptionalNumber(value: unknown): number | undefined {
  if (value === "" || value === undefined || value === null) {
    return undefined;
  }
  const n = typeof value === "number" ? value : Number(String(value).trim());
  return Number.isFinite(n) ? n : undefined;
}

export function transformMiqaatVenuePayload(data: Record<string, unknown>) {
  const d = { ...data };
  if (typeof d.name === "string") {
    d.name = d.name.trim();
  }
  d.latitude = parseOptionalNumber(d.latitude);
  d.longitude = parseOptionalNumber(d.longitude);
  const radius = parseOptionalNumber(d.radiusMeters);
  if (radius === undefined) {
    delete d.radiusMeters;
  } else {
    d.radiusMeters = Math.trunc(radius);
  }
  return d;
}
